module.exports = __webpack_public_path__ + "img/51626527_L.e28b3835.png";